export default {
    data() {
        return {
            navBarFixed: false
        }
    },
    mounted() {
        // 事件监听滚动条
        window.addEventListener("scroll", this.watchScroll);
    },
    destroyed() {
        // 移除事件监听
        window.removeEventListener("scroll", this.watchScroll);
    },
    methods: {
        watchScroll() {
            // 滚动的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;

            // 容器的高度
            // let offsetTop = document.querySelector("#nav").offsetHeight;
            //
            // console.log("scrollTop=>", scrollTop, "  offsetTop=>", offsetTop);

            //  滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
            if (scrollTop > 145) {
                this.navBarFixed = true;
            } else {
                this.navBarFixed = false;
            }
        }
    }
}
